<div class="dt-home">
  <div class="tools">
    <!-- Segment Preview Card -->
    <div class="dt-tool-card" (click)="selectTool('segment-preview')">
      <div class="header">
        <iris-icon name="analytics" [size]="iconSizes.LG" colorToken="$color-primary-50"></iris-icon>
        @if (segmentService.eventCount() > 0) {
          <span class="badge">{{ segmentService.eventCount() }}</span>
        }
      </div>
      <div class="body">
        <h4 class="title">Segment Preview</h4>
        <p class="description">
          View live Segment events as they're tracked in your app
        </p>
      </div>
      <div class="footer">
        <button class="cta" type="button">
          View Events
          <iris-icon name="arrow_forward" [size]="iconSizes.SM"></iris-icon>
        </button>
      </div>
    </div>

    <!-- Amplitude Feature Flags Card -->
    <div class="dt-tool-card" (click)="selectTool('amplitude-flags')">
      <div class="header">
        <iris-icon name="toggle_on" [size]="iconSizes.LG" colorToken="$color-primary-50"></iris-icon>
      </div>
      <div class="body">
        <h4 class="title">Amplitude Feature Flags</h4>
        <p class="description">
          Toggle feature flags on/off for testing and development
        </p>
      </div>
      <div class="footer">
        <button class="cta" type="button">
          Manage Flags
          <iris-icon name="arrow_forward" [size]="iconSizes.SM"></iris-icon>
        </button>
      </div>
    </div>

    <!-- Placeholder for future tools -->
    <div class="placeholder">
      <p>More tools coming soon...</p>
    </div>
  </div>
</div>
